import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Bell,
  Calendar,
  Flag,
  Tag,
  Target,
  Warning,
} from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { Task } from 'shared/types/task';

import { SubMenu } from './types';

export type EditListProps = {
  tasks: Task[];
  openSubMenu: (subMenu: SubMenu) => void;
};

export const EditList: React.FC<EditListProps> = ({ tasks, openSubMenu }) => {
  const { t } = useTranslation();
  const updatePriority = () => openSubMenu(SubMenu.Priority);
  const updateLinkedItem = () => openSubMenu(SubMenu.LinkedItem);
  const updateDeadlineDeadline = () => openSubMenu(SubMenu.DeadlineDeadline);
  const updateReminderTime = () => openSubMenu(SubMenu.ReminderTime);
  const updateDate = () => openSubMenu(SubMenu.Date);
  const updateTags = () => openSubMenu(SubMenu.Tags);

  // Check if there are no repeating tasks or habits
  const onlyTodos = tasks.every((task) => !task.schedules?.length);

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={updateLinkedItem}
          start={<Icon icon={Target} />}
        >
          {t('context-menus.task.multi-select.options.linked-item.label')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton onClick={updateDate} start={<Icon icon={Calendar} />}>
          {t('context-menus.task.multi-select.options.date.label')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={updatePriority}
          start={<Icon icon={Warning} />}
        >
          {t('context-menus.task.multi-select.options.priority.label')}
        </PopupMenuButton>
      </PopupMenuListItem>

      {onlyTodos && (
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={updateDeadlineDeadline}
            start={<Icon icon={Flag} />}
          >
            {t(
              'context-menus.task.multi-select.options.deadline-deadline.label',
            )}
          </PopupMenuButton>
        </PopupMenuListItem>
      )}

      <PopupMenuListItem>
        <PopupMenuButton onClick={updateTags} start={<Icon icon={Tag} />}>
          {t('context-menus.task.multi-select.options.tags.label')}
        </PopupMenuButton>
      </PopupMenuListItem>

      <PopupMenuListItem>
        <PopupMenuButton
          onClick={updateReminderTime}
          start={<Icon icon={Bell} />}
        >
          {t('context-menus.task.multi-select.options.reminder-time.label')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
